module.exports = __webpack_public_path__ + "img/broken_coupon.bc987731.png";